import { useEffect } from 'react';

const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
].join(',');

const getFocusableElements = (containerElement) => {
    if (!containerElement) {
        return [];
    }

    return Array.from(containerElement.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter((element) => !element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};

const useFocusTrap = (containerRef, active) => {
    useEffect(() => {
        if (!active || !containerRef.current) {
            return undefined;
        }

        const containerElement = containerRef.current;
        const focusableElements = getFocusableElements(containerElement);
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (firstElement && document.activeElement && !containerElement.contains(document.activeElement)) {
            firstElement.focus();
        }

        const handleKeyDown = (event) => {
            if (event.key !== 'Tab' || focusableElements.length === 0) {
                return;
            }

            if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
                return;
            }

            if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [active, containerRef]);
};

export default useFocusTrap;
